import React from 'react'
import Type5 from './type-5'

export default props => <Type5 {...props} top buyButton/>